import { Component, Input } from '@angular/core';
import { WhatsappForBusinessService } from '../../../../../services/whatsapp-for-business.service';
import { HelpersService } from '../../../../../services/helpers.service';

@Component({
  selector: 'app-whatsapp-initiate-chat-template',
  templateUrl: './whatsapp-initiate-chat-template.component.html',
  styleUrls: ['./whatsapp-initiate-chat-template.component.scss']
})
export class WhatsappInitiateChatTemplateComponent {
  
  @Input() isWorkshop;
  @Input() isRentals;

  public initiateChatTemplate : any = {};
  public busy : boolean = false;
  public showMessageType : boolean = false;

  constructor(
    private whatsappForBusinessService: WhatsappForBusinessService,
    private helpersService: HelpersService
  ) {}

  ngOnInit() {
    this.getWhatsAppInitiateChatTemplate();
  }

  getWhatsAppInitiateChatTemplate() {
    this.whatsappForBusinessService.getWhatsAppInitiateChatTemplate(this.helpersService.getPartnerId(), this.isWorkshop ? "WORKSHOP" : "RENTALS").subscribe(res => {
      this.initiateChatTemplate = res;
    });
  }

  openPanel(){
    this.showMessageType = true;
  }

  closePanel() {
    this.showMessageType = false;
  }

}
